import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PaymentSchedule from '../../../containers/member-payments-schedule-link.container';

import money, { format } from '../../../lib/money';
import Membership from '../../../lib/membership';
import { Time, TIME_FORMAT_SHORT } from '../../../../components/Time';
import getCardTypeName from '../../../lib/card-type-names';
import { SHARED_NAMESPACE } from '../../../actions';

class SummaryShareFailed extends Component {
  get contributionAmount() { return money(this.props.contributionAmount); }

  get nextPaymentAmount() { return money(this.props.nextPayment.amount); }

  renderNextContribution() {
    const { purchase, nextPayment } = this.props;
    const { paymentSource } = this.props.membership;

    if (!nextPayment) return;
    if (purchase.currentPayment && purchase.currentPayment.number === 1) return;

    const nextDate = <Time format={TIME_FORMAT_SHORT} time={nextPayment.dueDeadline} />;

    return (
      <p className="mt-3 small-print card-icons">
        <FormattedMessage
          id='summaryShare.failed.nextContribution'
          defaultMessage='Next payment will be {amount}, on or before {date} to your {card} ending in {ending}'
          values={{
            date: nextDate,
            amount: format(this.nextPaymentAmount),
            card: getCardTypeName(paymentSource.info.cardType),
            ending: paymentSource.info.lastFour,
          }}
        />
      </p>
    );
  }

  renderPaymentSchedule() {
    return (
      <div>
        <PaymentSchedule namespace={SHARED_NAMESPACE} />
      </div>
    );
  }

  get withdrawButton() {
    if (Membership.getPaidContributions(this.props.membership.contributions).length) return;
    return (
      <a className="d-block mt-3 mb-0" href="#withdraw" onClick={this.props.onWithdraw}>
        <FormattedMessage
          id="summaryShare.failed.withdraw"
          defaultMessage="Withdraw"
        />
      </a>
    );
  }

  render() {
    const { membership: { paymentSource } } = this.props;
    const date = (<Time format={TIME_FORMAT_SHORT} time={this.props.paymentDate} />);

    return (
      <div className="summary-share-failed yourshare-block gray">
        <div className="yourshare-box">
          <hr />
          <div className="contribute text-center">
            <div className="coral-error">
              <FormattedMessage
                id="summaryShare.failed.paymentFailed"
                defaultMessage="Your payment failed"
              />
            </div>
            <div>
              <h2 className="coral-error">
                {format(this.contributionAmount)}
              </h2>
              <p className="small-print card-icons">
                <FormattedMessage
                  id='summaryShare.failed.chargeAttempt'
                  defaultMessage='We tried to charge you on {date} to your {card} ending in {ending}'
                  values={{
                    date,
                    card: getCardTypeName(paymentSource.info.cardType),
                    ending: paymentSource.info.lastFour,
                  }}
                />
              </p>
            </div>
            <button
              type="button"
              onClick={this.props.onCommit}
              className="btn btn-primary btn-block"
            >
              <FormattedMessage
                id="summaryShare.failed.updatePayment"
                defaultMessage="Update payment"
              />
            </button>
            {this.withdrawButton}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(SummaryShareFailed);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/summary-share.failed.js